module.exports = __webpack_public_path__ + "img/07.c4c5c369.jpg";